import { Heading } from '@joehua/buzz-components'
import { AppConfig, makeImageLink } from '@joehua/cms-components'
import dlv from 'dlv'
import React from 'react'
import ReactMarkdown from 'react-markdown'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function LayoutCta() {
  return (
    <AppConfig>
      {({ data, imageHost }) => {
        const cta = dlv(data, 'cta', {})
        const imageId = makeImageLink({
          host: imageHost,
          image: data.cta.background,
          transform: 'w_1200',
        })
        return (
          <div
            className="cover bg-center aspect-ratio--4x3 aspect-ratio--16x9-m vh-75-l pb0-l relative"
            style={{ backgroundImage: `url(${imageId})` }}
          >
            <div className="absolute absolute--fill bg-black-20 z-0" />
            <div className="absolute absolute--fill flex items-center justify-center z-1">
            <div className="w-100 mw7 center ph2 ph3-ns pv3 tc">
              <Heading
                data={{ title: cta.title, titleTag: 'h2' }}
                theme={{
                  root: 'ph3 pr4',
                  title: 'white rf fw7 w-100 f3 f2-l ma0 lh-title',
                }}
              />
              <ReactMarkdown source={cta.body} className="pf fw7 white-90 lh-copy pr4 ph3" />
              <div className="pv1 flex items-center ph3 justify-center">
                <FontAwesomeIcon
                  icon="phone-volume"
                  color="#fff"
                  size="2x"
                />{' '}
                <a href={`tel:${cta.phone}`} className="link dim">
                  <span className="white fw7 f5 f4-l ph2">{cta.phone}</span>
                </a>
              </div>
              <div className="pv1 flex items-center ph3 justify-center">
                <FontAwesomeIcon icon="users" color="#fff" size="2x" />{' '}
                <a href="/lien-he" className="link dim">
                  <span className="white fw7 f5 f4-l ph2">{cta.cta}</span>
                </a>
              </div>
            </div>
            </div>
          </div>
        )
      }}
    </AppConfig>
  )
}
